/* @flow */
import AuthenticationView from 'auth/components/AuthenticationView';
import Button from 'components/ButtonDeprecated';
import * as React from 'react';

import 'styles/utilities.scss';

export class SessionExpiredPage extends React.Component<{}> {
  render() {
    return (
      <AuthenticationView title="Session expired">
        <p className="block">For your security, you have been logged out of your Remind session.</p>
        <Button to="/log_in">Log back in</Button>
      </AuthenticationView>
    );
  }
}

export default SessionExpiredPage;
